import React from "react";
import styled from "styled-components";

export default function BackgroundImage({background}) {
  return (
    <Container>
      <img src={background} alt="background" />
    </Container>
  );
}

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  img {
    height: 100%;
    width: 100%;
  }
`;
